module.exports = __webpack_public_path__ + "media/KION GB 2017_Linde EMEA_Remanufacturing-1080p-DE.07d16151.mp4";